export default {
	"comillas": {
		"name": "comillas",
		"basic": {
			"default": "#303338",
			"alternative": "#ffb81c",
			"fontAlternative": "#202020",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#ffb81c",
			"font": "#303338",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#97999b",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		languagebydefault:"es",
		"hasFavicon": true,
		"logo": "/static/img/brands/comillas/logo.svg",
		"logocolor": "/static/img/brands/comillas/logo.svg",
		"logodarkmode": "/static/img/brands/comillas/logo-white.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/comillas/background.jpg",
		"emailContacto": "mftorres@comillas.edu",
		"emailInscripcion": "oia@comillas.edu",
		"emailProblemas": "oia@comillas.edu",
		"emailJuridica": "practicas.derecho@comillas.edu",
		"emailIngenieria": "practicas.ingenieria@comillas.edu",
		"emailEconomica": "practicas.ade.ibs@comillas.edu",
		"emailSanitaria": "practicas.soci.sani@comillas.edu",
		"emailEducacion": "mvtorres@comillas.edu",
		"emailRRII": "practicas.ri.com.ti@comillas.edu",
		"emailInternacional": "jrmunoz@comillas.edu",
		"hideSAML": true,
		"ownpopup_info": {
			"editar_personales": {
				"titulo": "Edición de datos personales",
				"texto": "Si alguno de los datos no editables no es correcto, por favor, accede a tu intranet para modificarlos."
			}
		},
		"footer": {
			"es": {
				"textos": [
					"© Universidad Pontificia Comillas"
				],
				"links": {
					"Aviso Legal": "https://www.comillas.edu/Documentos/Aviso_Legal.pdf",
					"Política de Cookies": "https://www.comillas.edu/es/politica-de-cookies",
				}
			},
			"en": {
				"textos": [
					"© University Pontificia Comillas"
				],
				"links": {
					"Legal notice": "https://www.comillas.edu/Documentos/Aviso_Legal.pdf",
					"Cookies Policy": "https://www.comillas.edu/es/politica-de-cookies",
				}
			}
		},
		"fonts": {
			"link": "family=Muli:300,400,500,700,800",
			"principal": "'Muli', sans-serif",
			"secundaria": "'Muli', sans-serif"
		},
		"ownstyles": "/static/img/brands/comillas/style.css",
		"logintexts": {
			"es": {
				"antiguos": "Antiguos Alumnos",
				"estudiantes": "Estudiantes",
				"empresas": "Empresas"
			},
			"en": {
				"antiguos": "Old Students",
				"estudiantes": "Students",
				"empresas": "Companies"
			}
		},

	
		//PROPUESTA DE PRACTICAS
		"instruccionesPropuestaPracticas": "",
		"showPropuestaPracticas": true,
		"ocultarInfoAux": true,

		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": true,
		"inscripcionExterna": true,
		"programasInformaticosNoPersonalizables": true,
		"requestDatosTutorEnOferta": false,
		"hideCamposTutor": ["cargo", "departamento"],
		"showDireccionEmpresa": true,
		"requestDatosFirmanteEnPropuesta":true,
		"requestDatosFirmanteEnOferta": false,
		"busquedaPuestoEmpresa": true,
		"listBusquedaPractica":['areaFuncional', 'tiposFormacion', 'titulaciones', 'tituloPrograma', 'tipoModalidadAsistencia'],
		"renunciaPracticasSET" : true,
		
		"niveles": [
			{
				id: "grado",
				active: false,
				label: {
					"es": "Grado",
					"ca": "Grau",
					"en": "Degree"
				}
			},
			{
				id: "postgrado",
				active: false,
				label: {
					"es": "Postgrado",
					"ca": "Postgrau",
					"en": "Postgraduate"
				}
			},
			{
				id: "doctorado", 
				active: false,
				label: {
					"es": "Doctorado",
					"ca": "Doctorat",
					"en": "Doctorate"
				}
			}
		],

		
		"camposOferta": {
			"otraRemuneracion": {
				"label": {
					"es": "Otra remuneración",
					"en": "Other remuneration"
				},
				"showIn": ['Practicas', 'Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": {
					"es": "Remuneración(€ brutos/mes)",
					"en": "Remuneration(€ gross/month)"
				},
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": {
					"es": "Área funcional",
					"en": "Functional area"
				},
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"descripcion": {
				"label": {
					"Empleo": {
						"es": "Descripción del puesto*",
						"en": "Job description*"
					},
					"Practicas": {
						"es": "Descripción del puesto*",
						"en": "Job description*"
					}
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"paraEstudiantesUltimoCurso": {
				"showIn": ['Practicas'],
			},
			"modalidad": {
				"showIn": ['Empleo', 'Practicas']
			},
			"urlInformacionComplementaria": {
				"showIn": ['Empleo', 'Practicas']
			},
			"gestionOfertasConEstudiosPropuestos": {
				"showIn": ['Empleo', 'Practicas']
			}
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración (€ brutos/mes)",
			},
			"tutorEmpresa": {
				"titulacion": true,
				"dni": true,
				"telefono": true
			},
			"practicaRemunerada": {
				"label": {
					"es": "Práctica remunerada",
					"en": "Paid internship"
				},
				"showIn": ['Practicas']
			},
			"direccion": {
				"label": "direccion",
			},			
			"tipoPracticaCurriExtracurri": true,
			"solicitudParaCentroEducativo": false,
		},

		//REGISTRO DE LA EMPRESA
		"requestStartUp": true,
		"requestTipoEmpresa": true,
		"requestDireccionFullContactoEmpresa": true,
		"requestDireccionContactoEmpresa": true,
		"hideDniFirmante" : true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
		},

		//CV DEL CANDIDATO
		"quitarCampoDiscapacidad": true,
		"canEditPeriodoPracticas": true,
		"sectoresInteres" : true,
		"checkIbanInPracticasConServicio": true,
		"hasDocumentacionPrivadaCV": true,
		"hasDocumentacionLigadaProcesos": true,
		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"emailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"movil": {
				"visible": true,
				"editable": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"iban": {
				"visible": true,
				"editable": true,
				"required": false
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true,
					"hide": []
				},
				"2": {
					"visible": true,
					"editable": true,
					"hide": []
				}
			}
		},

		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			}
		},

		"interes": {},

		//DOCUMENTACIÓN DE EMPRESAS
		"haveDocumentosPracticas": true,
		"canSubirConvenios" : true,
		
		//REGISTRO DE LOS ALUMNOS
		"ownlogin": {
			"hasEstudiante": true,
			"hasEgresado": true,
			"textoEstudiantes": {
				"es": "Los estudiantes de Comillas disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>",
				"en": "The students of Comillas have their own username and password for access to the services and systems of the University.<strong>Access below to identify yourself.</strong>"
			},
			"textoEgresados": {
				"es": "Los antiguos alumnos de Comillas disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>",
				"en": "The old students of Comillas have their own username and password for access to the services and systems of the University.<strong>Access below to identify yourself.</strong>"
			}
		},
		"infoAlumno" : true,
	},
}


// WEBPACK FOOTER //
// ./src/brands/brands.js